export enum EnumWorkflowHeaderColorStatus {
  Green = 1,
  Yellow = 2,
  Red = 3,
}
